import React from 'react';
import Star from "./Star";
import styles from "./Rating.module.css";
interface RatingProps {
  score: number;
}
const Rating: React.FC<RatingProps> = ({
  score
}) => {
  const totalStars = 5;
  let stars = [];
  for (let i = 1; i <= totalStars; i++) {
    stars.push(<Star key={i} value={i <= score ? 1 : i - 1 < score && i > score ? score % 1 : 0} />);
  }
  return <div className={styles.starContainer} data-sentry-component="Rating" data-sentry-source-file="Rating.tsx">
              {stars}
              <p className='text-black'>{score.toFixed(1)}</p>
              
          </div>;
};
export default Rating;